#import "../../../graphql/fragments/coordinates-fragment.graphql"
#import "../../../graphql/fragments/location-weather-fragment.graphql"

fragment ContactPrimaryAccountFragment on ContactAccountsEdge {
    relationshipNote
    node {
        id
        name
        htmlUrlPath
        postalAddresses {
            primary {
                location {
                    coordinates {
                        ...CoordinatesFragment
                    }
                    weather {
                        ...LocationWeatherFragment
                    }
                }
            }
        }
    }
}
